import React from 'react';
import { useSelector } from 'react-redux';
import { Wrapper, Title } from '../../styles';

import utils from 'utils';
import selectors from 'state/selectors';

import Chart from 'components/Chart/Chart';
import Table, { TableProps } from 'components/Table';
import Legenda, { Item } from 'components/Legenda';
import Icon from 'components/Input/Icon';
import { IconsStatusContainer } from 'routes/Configurator/styles';
import Typography from 'components/Typography/Typography';

const Disk = () => {
  const t = utils.intl.useTranslator();
  const diskCount = useSelector(selectors.normalizer.getDashboardDiskCount);
  const diskStatus = useSelector(selectors.normalizer.getDashboardDiskStatus);
  const columns: TableProps['columns'] = [
    {
      Header: t('path'),
      accessor: 'path',
      filterType: 'free',
      width: 400,
    },
    {
      Header: t('status'),
      accessor: 'status',
      filterType: 'select',
      width: 200,
      Cell: ({ value }: { value: number }) => {
        try {
          const icons: JSX.Element[] = [];
          switch (value) {
            case 0:
              icons.push(
                <span>
                  <Icon icon="green-circle" size="lg" />
                </span>,
              );
              break;
            case 1:
              icons.push(
                <span>
                  <Icon icon="red-circle" size="lg" />
                </span>,
              );
              break;
          }
          return <IconsStatusContainer>{icons}</IconsStatusContainer>;
        } catch (e) {
          console.error(e);
          return null;
        }
      },
    },
    {
      Header: t('docName'),
      accessor: 'docName',
      filterType: 'select',
      width: 300,
    },
    {
      Header: t('company'),
      accessor: 'company',
      filterType: 'select',
      width: 300,
    },
  ];
  const legendaProps: Item[][] = [
    [
      {
        icon: 'green-circle',
        label: t('active'),
      },
      {
        icon: 'red-circle',
        label: t('blocked'),
      },
    ],
  ];

  const specialColumns = {
    status: (value: any) => {
      switch (value.status) {
        case 0:
          return t('active');
        case 1:
          return t('blocked');
      }
      return '';
    },
  };

  return (
    <Wrapper>
      <Title>
        <h2>{t('disk_title')}</h2>
      </Title>
      {diskStatus.length ? (
        <>
          <Legenda items={legendaProps} />
          <Table
            id="disk-status-table"
            hasPagination
            hasToolbar
            rowId="path"
            columns={columns}
            rows={diskStatus}
            specialColumns={specialColumns}
          />
        </>
      ) : (
        <Typography as="h1">{t('no_data')}</Typography>
      )}
      {diskCount.length ? (
        <Chart dataValues={diskCount.map(({ path, count }) => ({ label: path, count }))} />
      ) : (
        <Typography as="h1">{t('no_data')}</Typography>
      )}
    </Wrapper>
  );
};

export default Disk;
